import { useTranslation } from "@luckymenu/i18n/react";
import { useCan } from "@luckymenu/staff-core";
import { buttonVariants, PageHeader } from "@luckymenu/ui-web";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { BackToMenu } from "../features/menu/back-link";
import { CategoryList } from "../features/menu/category-list";
import { BottomBar } from "../features/menu/fields";
import { PaneHint, useInPanes } from "../features/menu/panes";

export const Route = createFileRoute("/menu/categories/")({ component: Page });

function Page() {
	const inPanes = useInPanes();
	const { t } = useTranslation("menu");
	const canEdit = useCan("menu.edit");
	if (inPanes) return <PaneHint />;
	return (
		<div className="grid max-w-3xl gap-1 pb-28 md:pb-0">
			<BackToMenu />
			<PageHeader
				title={t("categories")}
				description={canEdit ? t("categoriesHint") : undefined}
				actions={
					canEdit ? (
						<Link
							to="/menu/categories/new"
							className={buttonVariants({ className: "max-md:hidden" })}
						>
							<Plus data-icon="inline-start" />
							{t("addCategory")}
						</Link>
					) : null
				}
			/>
			<CategoryList
				title={(category) =>
					canEdit ? (
						<Link
							to="/menu/categories/$categoryId"
							params={{ categoryId: category.id }}
							className="outline-none hover:underline focus-visible:underline"
						>
							{category.name}
						</Link>
					) : (
						category.name
					)
				}
			/>
			{canEdit ? (
				<div className="md:hidden">
					<BottomBar>
						<Link
							to="/menu/categories/new"
							className={buttonVariants({ size: "lg", className: "w-full" })}
						>
							<Plus data-icon="inline-start" />
							{t("addCategory")}
						</Link>
					</BottomBar>
				</div>
			) : null}
		</div>
	);
}
